(ns app.front.view.admin.commands.review-acceptances
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::fetch-reviews
  (fn [{:keys [db]} [_ workspace-id]]
    {:comm/command {:command    :admin/workspace-reviews-and-acceptances
                    :data       (util/mmap workspace-id)
                    :on-success [::fetch-reviews.success]}
     :db           (update db ::state dissoc :reviews)}))

(rf/reg-event-db ::fetch-reviews.success
  (fn [db [_ status reviews]]
    (if (= 200 status)
      (assoc-in db [::state :reviews] reviews)
      db)))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-sub ::reviews
  :<- [::state]
  :-> :reviews)

(rf/reg-sub ::fetched?
  :<- [::state]
  (fn [state _] (some? (:reviews state))))

(rf/reg-event-fx ::set-acceptance-value
  (fn [_ [_ acceptance-id value]]
    {:comm/command {:command :admin/set-acceptance-value
                    :data    {:acceptance-id acceptance-id
                              :value         value}
                    :notify  {:success "Acceptance value updated"}}}))

(defn- acceptance-row [acc]
  [:tr
   [:td.p-2.border [:a {:href (href/href :view/admin.entity-lookup-with-param {:search-term (:db/id acc)})} (:db/id acc)]]
   [:td.p-2.border (some-> (:domain/state acc) name)]
   [:td.p-2.border (some-> (:acceptance/value acc) name)]
   [:td.p-2.border (some-> acc :entity/parent :entity/type name)]
   [:td.p-2.border (some-> acc :entity/parent :entity/type str)]
   [:td.p-2.border (some-> acc :acceptance/text)]
   [:td.p-2.border
    (r/with-let [*value (r/atom nil)]
      [:div.flex.items-center.gap-2
       [ui-select/select {:id           (str "acc-val-" (:db/id acc))
                          :value        @*value
                          :values       [:acceptance.value/ok :acceptance.value/needs-changes]
                          :val->str     name
                          :on-change    #(reset! *value %)
                          :allow-empty? true
                          :label-text   ""}]
       (cc/button {:kind     :primary
                   :size     :small
                   :disabled (nil? @*value)
                   :on-click #(>evt [::set-acceptance-value (:db/id acc) @*value])}
                  "Set")])]])

(defn- review-section [review]
  [:div.mb-6.p-4.bg-ui-light-gray.rounded-md
   [:div.flex.gap-4.mb-2
    [:span.font-semibold "Review " (str (:db/id review))]
    [:span "Status: " (some-> (:review/status review) name)]
    (when-let [rc (:review/review-config review)]
      (let [config-name (->> (:review.config/name rc)
                             (some #(when (= :en (:entity/language %))
                                      (:localized-string/text %))))]
        [:span "Config: " (or config-name (str (:db/id rc)))]))]
   (if (seq (:review/acceptances review))
     [:table.w-full.border-collapse
      [:thead
       [:tr
        [:th.p-2.border.text-left "Acceptance ID"]
        [:th.p-2.border.text-left "State"]
        [:th.p-2.border.text-left "Value"]
        [:th.p-2.border.text-left "Parent type"]
        [:th.p-2.border.text-left "Parent type"]
        [:th.p-2.border.text-left "Text"]
        [:th.p-2.border.text-left "Change value"]]]
      [:tbody
       (for [acc (:review/acceptances review)]
         ^{:key (:db/id acc)}
         [acceptance-row acc])]]
     [:p.text-gray-500 "No acceptances"])])

(defn view [match]
  (r/with-let [*workspace-id (r/atom nil)]
    [acommon/admin-page
     (util/mmap {:title "Review acceptances browser"} match)
     [:section
      [:p "Look up all reviews under a workspace and their linked acceptances. "
       "Allows force-setting an acceptance value."]
      [:div.flex.items-end.gap-3.mt-4
       [:div.w-1-3
        [ui/text-input {:id          "review-ws-id"
                        :light       true
                        :value       @*workspace-id
                        :on-change   #(reset! *workspace-id (futil/tval %))
                        :placeholder "CA-1234567-B-12345"
                        :label-text  "Workspace ID"}]]
       (cc/button {:kind     :primary
                   :size     :field
                   :disabled (not (workspace-model/workspace-id? @*workspace-id))
                   :on-click #(>evt [::fetch-reviews @*workspace-id])}
                  "Fetch reviews")]]
     (when (<sub [::fetched?])
       (let [reviews (<sub [::reviews])]
         [:section.mt-4
          (if (seq reviews)
            (for [review reviews]
              ^{:key (:db/id review)}
              [review-section review])
            [:p "No reviews found for this workspace."])]))]))

(def route
  {:name :view/admin.commands.review-acceptances
   :view view})
